import React, { useState } from "react";
import "../../../assets/css/patient/Card.css";

const TherapyPage = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const services = [
    {
      id: "appointment",
      title: "Doctor Appointment",
      subtitle: "In-Person Clinical Care",
      description: "Schedule comprehensive face-to-face consultations with board-certified speech-language pathologists.",
      icon: "👨‍⚕️",
      features: ["Clinical Assessment", "Treatment Planning", "Progress Reports", "Follow-up Care"],
      stats: [
        { value: "500+", label: "Doctors" },
        { value: "4.9★", label: "Rating" },
        { value: "15min", label: "Avg Wait" },
      ],
    },
    {
      id: "ai",
      title: "AI Mental Health Support",
      subtitle: "24/7 Intelligent Assistance",
      description: "Our advanced AI analyzes your mental health patterns in real-time, providing personalized guidance and adaptive support tailored to your unique journey.",
      icon: "🤖",
      features: ["Real-time Analysis", "Personalized Insights", "Mood Tracking", "Crisis Detection"],
      stats: [
        { value: "24/7", label: "Available" },
        { value: "98%",  label: "Accuracy" },
        { value: "<1s",  label: "Response" },
      ],
    },
    {
      id: "emergency",
      title: "Emergency Consultation",
      subtitle: "Urgent Care Support",
      description: "Immediate access to on-call speech therapists for urgent concerns and crisis situations.",
      icon: "🚨",
      features: ["24/7 Availability", "15-min Response", "Crisis Support", "Rapid Assessment"],
      stats: [
        { value: "15min", label: "Response" },
        { value: "100%",  label: "Available" },
        { value: "3000+", label: "Cases" },
      ],
    },
  ];

  return (
    <div className="therapy-wrapper">
      <div className="particles">
        {[...Array(8)].map((_, i) => <div key={i} className="particle" />)}
      </div>
      <div className="floating-shape shape-1" />
      <div className="floating-shape shape-2" />
      <div className="floating-shape shape-3" />

      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <div className="therapy-badge">
            <div className="pulse-dot" />
            <span>Clinical Speech Therapy Services</span>
          </div>
          <h1 className="therapy-title">
            Professional Speech & Language <br />
            <span className="gradient-text">Medical Treatment Center</span>
          </h1>
          <p className="therapy-desc">
            Evidence-based therapy programs delivered by licensed speech-language pathologists (SLP).
          </p>
        </div>

        <div className="mb-5 text-center">
          <h2 className="services-title">Our Therapy Services</h2>
          <p className="services-sub">
            Choose the right therapy option — in-person, AI-powered, or emergency care
          </p>
        </div>

        {/* Cards */}
        <div className="row g-4 mb-5">
          {services.map((service, index) => (
            <div key={service.id} className="col-lg-4 col-md-6">
              <div
                className="service-card"
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="card-shine" />
                <div className="service-card-body">

                  <div className="service-icon-wrapper">
                    <span className="service-icon">{service.icon}</span>
                  </div>

                  <h4 className="service-title">{service.title}</h4>
                  <span className="service-subtitle">{service.subtitle}</span>
                  <p className="service-text">{service.description}</p>

                  <div className="feature-list">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="feature-item">
                        <span className="check-icon">✓</span>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>

                  <div className="card-stats">
                    {service.stats.map((stat, idx) => (
                      <React.Fragment key={idx}>
                        <div className="card-stat">
                          <span className="card-stat-value">{stat.value}</span>
                          <span className="card-stat-label">{stat.label}</span>
                        </div>
                        {idx < service.stats.length - 1 && <div className="card-stat-divider" />}
                      </React.Fragment>
                    ))}
                  </div>

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TherapyPage;